(ns machtfit.startpage.products-cache
  (:require ["base32768" :as base32768]
            ["fflate" :as fflate]
            [cljs-time.coerce :as time.coerce]
            [cljs-time.core :as time]
            [cljs.reader :as reader]
            [clojure.string :as str]
            [machtfit.storage :as-alias storage]))

(def current-version 3)

(defn assemble-cache-key [db]
  (let [cache-key (-> db :user :products-cache-key)
        location (get-in db [:products-location :coordinates])]
    (str cache-key "-" (str/join "-" location))))

(defn- encode-products [products]
  (let [text (pr-str products)
        byte-arr (.encode (js/TextEncoder.) text)
        gz (fflate/gzipSync byte-arr #js {:level 1})]
    (base32768/encode gz)))

(defn- decode-cached-products [compressed]
  (when compressed
    (try
      (let [byte-arr (base32768/decode compressed)
            gz (fflate/gunzipSync byte-arr)
            text (.decode (js/TextDecoder.) gz)]
        (reader/read-string text))
      (catch js/Object e
        (js/console.warn "Failed to decode cached products; ignoring cache" e)
        nil))))

(defn restore-from-session-storage [db session-storage]
  (let [timestamp (session-storage 'machtfit.app.startpage.timestamp)
        version (session-storage 'machtfit.app.startpage.version)
        fresh? (and (some? timestamp)
                    (-> (time/now)
                        time.coerce/to-long
                        (- timestamp)
                        (<= (* 15 60 1000))))
        current-version? (= version current-version)
        products (decode-cached-products (session-storage 'machtfit.app.startpage.products))]
    (cond-> db
      (and current-version? fresh? (some? products))
      (assoc :products-cache {:cache-key (session-storage 'machtfit.app.startpage.products-cache-key)
                              :products products}))))

(defn ready? [db]
  (-> db :user :products-cache-key))

(defn hit? [db]
  (= (-> db :products-cache :cache-key) (assemble-cache-key db)))

(defn cached-products [db]
  (-> db :products-cache :products))

(defn store [path fx]
  (let [timestamp (time.coerce/to-long (time/now))
        products (-> fx :db (get-in path))
        cache-key (assemble-cache-key (:db fx))]
    (update fx ::storage/local-storage-put assoc
            'machtfit.app.startpage.timestamp timestamp
            'machtfit.app.startpage.version current-version
            'machtfit.app.startpage.products (encode-products products)
            'machtfit.app.startpage.products-cache-key cache-key)))
